<template>
  <div class="body-right">
    <div class="title-body-right">
      <h1 class="title-page">{{ $t('employee.title') }}</h1>

      <div class="group-btn">
        <el-button
          v-if="userInfo.type === ERolAdmin.ADMIN"
          class="btn"
          type="primary"
          @click="handleOpenAddDialog()"
        >
          {{ $t('employee.addButton') }}
        </el-button>

        <el-button
          class="btn btn-search-sp"
          type="primary"
          @click="toggleSearchBlock()"
        >
          {{ $t('common.toggleMenu') }}
        </el-button>
      </div>
    </div>

    <div class="search-wrap">
      <div class="search-form" :class="openSearchForm ? 'visible' : 'hidden'">
        <el-form
          :inline="true"
          :model="search"
          class="form"
          @submit.native.prevent
          @keyup.enter.native="onSubmitSearchForm"
        >
          <el-form-item>
            <el-input
              v-model="search.store"
              :placeholder="$t('employee.searchStore')"
              class="search-input"
              maxlength="225"
            >
              <i
                slot="suffix"
                class="el-input__icon el-icon-circle-close el-input__clear"
                @click="search.store = ''"
                v-if="search.store"
              ></i>
            </el-input>
          </el-form-item>

          <el-form-item>
            <el-input
              v-model="search.name"
              :placeholder="$t('employee.searchName')"
              class="search-input"
              maxlength="225"
            >
              <i
                slot="suffix"
                class="el-input__icon el-icon-circle-close el-input__clear"
                @click="search.name = ''"
                v-if="search.name"
              ></i>
            </el-input>
          </el-form-item>

          <el-form-item>
            <el-button
              class="search-button"
              type="primary"
              @click="onSubmitSearchForm"
            >
              {{ $t('employee.search') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>

      <el-row
        class="total-table"
        :class="openSearchForm ? 'total-table-absolute' : ''"
      >
        {{ $t('employee.total') }}: {{ employee.total }}
      </el-row>
    </div>

    <table-employee
      :dataColumn="employee.data"
      :currentPage="+employee.currentPage"
    />

    <div class="pagination">
      <base-pagination
        :totalPage="employee.total"
        @changePage="changeCurrentPage"
        :currentPage="+$route.query.page"
      >
      </base-pagination>
    </div>

    <add-employee-dialog
      :openAddDialog="openAddDialog"
      @handleCloseAddDialog="handleCloseAddDialog()"
    />
  </div>
</template>

<script>
import { LIMIT, PAGE } from '@/constants/common';
import { mapActions, mapGetters } from 'vuex';

import { redirectRouter } from '@/helper';
import * as pageRouter from '@/constants/pageRouter';
const BasePagination = () => import('@/components/BasePagination');
import { ERolAdmin } from '@/enums/user';

const AddEmployeeDialog = () => import('./AddEmployeeDialog');
const TableEmployee = () => import('./TableListEmployee');

export default {
  name: 'ListEmployee',
  components: {
    BasePagination,
    AddEmployeeDialog,
    TableEmployee,
  },
  data() {
    return {
      ERolAdmin,
      openAddDialog: false,
      search: {
        name: undefined,
        store: undefined,
        page: PAGE,
        limit: LIMIT,
      },
      formLabelWidth: '120px',
      openSearchForm: true,
    };
  },
  computed: {
    ...mapGetters('employee', ['employee', 'error']),
    ...mapGetters('user', ['userInfo']),
  },
  methods: {
    ...mapActions('employee', ['getEmployeeList']),
    ...mapActions('user', ['getInfoUser']),
    handleOpenAddDialog() {
      this.openAddDialog = true;
    },
    handleCloseAddDialog() {
      this.openAddDialog = false;
    },
    onSubmitSearchForm() {
      this.search = {
        ...this.search,
        name: this.search.name ? this.search.name.trim() : undefined,
        store: this.search.store ? this.search.store.trim() : undefined,
        page: PAGE,
      };

      this.getEmployeeList(this.search);

      redirectRouter({
        path: pageRouter.EMPLOYEE,
        query: {
          name: this.search.name ? this.search.name.trim() : undefined,
          store: this.search.store ? this.search.store.trim() : undefined,
          page: this.search.page,
        },
      });
    },

    changeCurrentPage(e) {
      this.search = {
        ...this.$router.currentRoute.query,
        page: e.page,
        limit: LIMIT,
      };

      this.getEmployeeList(this.search);

      redirectRouter({
        path: pageRouter.EMPLOYEE,
        query: {
          ...this.$router.currentRoute.query,
          page: this.search.page || undefined,
        },
      });
    },
    toggleSearchBlock() {
      this.openSearchForm = !this.openSearchForm;
    },
  },
  created() {
    this.search = {
      ...this.search,
      ...this.$router.currentRoute.query,
    };
    this.getEmployeeList(this.search);
    this.getInfoUser();
  },
};
</script>

<style lang="scss">
@import '@/styles/common.scss';
</style>
